import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/pages/Home'
import Vrbox from '@/pages/Vrbox'
import Oauth from '@/pages/Oauth'
/*import Entryform from '@/pages/Entryform'*/

Vue.use(Router)
export default new Router({
	  model:'history',
	  base:__dirname,
	  routes: [
	    {
	      path: '/Home',
	      name: 'Home',
	      component: Home,
	      meta:{
	      	title:'冷酸灵网展厅',
	      	content:'',
	      	desc:'首页'
	      }
	    },
	    {
	      path: '/Vrbox',
	      name: 'Vrbox',
	      component: Vrbox,
	      meta:{
	      	title:'冷酸灵翻糖寻宝行动',
	      	content:'',
	      	desc:'VR互动'
	      }
	    },
	    {
	      path: '/Oauth',
	      name: 'Oauth',
	      component: Oauth,
	      meta:{
	      	title:'VR互动用户授权',
	      	content:'',
	      	desc:'用户授权'
	      }
	    },
	  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js